// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#eu-council-game-container {
  position: absolute;
  top: 0;
  z-index: 1;
}

.testContainer {
  position: relative;
  top: 0;
  left: 12rem;
  width: 31rem;
  height: 30rem;
}

.page-title {
  padding-top: 0.75rem;
  text-align: center;
}
.page-title .label {
  color: var(--color-primary-blue);
  font-size: 1rem;
}

.tabs {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 1rem;
}
.tabs .tab {
  position: relative;
  border-radius: 8px;
  border: 2px solid rgba(0, 51, 153, 0.32);
  box-sizing: border-box;
  width: fit-content;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  color: var(--color-primary-blue);
  cursor: pointer;
}
.tabs .tab:hover {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, var(--color-white) 100%);
  border: 0;
  border-radius: 8px;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
}
.tabs .tab .label {
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  padding: 0.5rem 1.042rem;
}
.tabs .tab:not(.active):hover .label {
  padding: calc(0.5rem + 2px) calc(1.042rem + 2px);
}
.tabs .tab.active {
  font-weight: bold;
  border: 0;
  background-color: var(--color-light-blue);
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
}
.tabs .tab.active .label {
  padding: calc(0.5rem + 2px) calc(1.042rem + 2px);
}
.tabs .tab.active:before {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, var(--color-white) 100%);
  content: "";
  display: block;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 8px;
  width: 100%;
  z-index: 1;
}
.tabs .tab.active:after {
  content: "";
  width: 1rem;
  height: 1rem;
  position: absolute;
  bottom: -0.458rem;
  left: calc(50% + 0.5rem);
  transform: translateX(-100%) rotateZ(45deg);
  z-index: 0;
  background: var(--color-light-blue);
  box-shadow: 2px 2px 0 0 rgba(0, 0, 0, 0.16);
}
.tabs .tab:not(last-child) {
  margin-right: 1.25rem;
}

.badge {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.badge .icon {
  position: relative;
  max-width: 160px;
  width: 6.667rem;
}
.badge .icon .bg {
  width: auto;
  height: 100%;
}
.badge .icon .image {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: auto;
}
.badge .icon .info {
  position: absolute;
  top: 0;
  right: 0;
  max-width: 2rem;
  height: auto;
  margin-top: -0.5rem;
  width: 33%;
  min-width: 1.15rem;
}
.badge .icon .info .text {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-green);
  margin-top: -0.2rem;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0;
  text-align: center;
}
.badge .box {
  display: flex;
  z-index: 2;
  flex-direction: column;
  justify-content: center;
  border-radius: 2rem;
  background: rgba(0, 51, 153, 0.2);
  margin-top: -0.75rem;
  text-align: center;
  padding-left: 2rem;
  padding-right: 2rem;
}
.badge .box .title {
  color: var(--color-white);
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1rem;
  text-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.24);
  padding-top: 0.5rem;
}
.badge .box .description {
  color: var(--color-primary-blue);
  font-size: 0.667rem;
  font-weight: 600;
  line-height: 1rem;
  padding-bottom: 0.3rem;
}
.badge.locked .icon .bg {
  visibility: hidden;
}
.badge.locked .box {
  background: none;
}`, "",{"version":3,"sources":["webpack://./src/app/game/test/test.page.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,UAAA;AACF;;AAMA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAHF;;AAMA;EACE,oBAAA;EACA,kBAAA;AAHF;AAKE;EACE,gCAAA;EACA,eAAA;AAHJ;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAJF;AAME;EACE,kBAAA;EACA,kBAAA;EACA,wCAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AAJJ;AAMI;EACE,qFAAA;EAKA,SAAA;EACA,kBAAA;EACA,yCAAA;AARN;AAWI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,wBAAA;AATN;AAYI;EACE,gDAAA;AAVN;AAaI;EACE,iBAAA;EACA,SAAA;EACA,yCAAA;EACA,yCAAA;AAXN;AAYM;EACE,gDAAA;AAVR;AAaM;EACE,qFAAA;EAKA,WAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAfR;AAkBM;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,wBAAA;EACA,2CAAA;EACA,UAAA;EACA,mCAAA;EACA,2CAAA;AAhBR;AAoBI;EACE,qBAAA;AAlBN;;AAuBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AApBF;AAsBE;EACE,kBAAA;EACA,gBAAA;EAEA,eAAA;AArBJ;AAuBI;EACE,WAAA;EACA,YAAA;AArBN;AAwBI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AAtBN;AAyBI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AAvBN;AAwBM;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAtBR;AA0BE;EACE,aAAA;EACA,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAxBJ;AA0BI;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,0CAAA;EACA,mBAAA;AAxBN;AA0BI;EACE,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAxBN;AA4BI;EACE,kBAAA;AA1BN;AA4BI;EACE,gBAAA;AA1BN","sourcesContent":["#eu-council-game-container {\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  // max-width: 1600px;\n  // max-height: 900px;\n  // display: flex;\n  // flex-direction: column;\n}\n\n.testContainer {\n  position: relative;\n  top: 0;\n  left: 12rem;\n  width: 31rem;\n  height: 30rem;\n}\n\n.page-title {\n  padding-top: 0.75rem;\n  text-align: center;\n\n  .label {\n    color: var(--color-primary-blue);\n    font-size: 1rem;\n  }\n}\n\n.tabs {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-bottom: 1rem;\n\n  .tab {\n    position: relative;\n    border-radius: 8px;\n    border: 2px solid rgba(0, 51, 153, 0.32);\n    box-sizing: border-box;\n    width: fit-content;\n    font-size: 1rem;\n    font-weight: 600;\n    text-align: center;\n    color: var(--color-primary-blue);\n    cursor: pointer;\n\n    &:hover {\n      background: linear-gradient(\n        0deg,\n        rgba(255, 255, 255, 0) 0%,\n        var(--color-white) 100%\n      );\n      border: 0;\n      border-radius: 8px;\n      box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);\n    }\n\n    & .label {\n      position: relative;\n      width: 100%;\n      height: auto;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      z-index: 2;\n      padding: 0.5rem 1.042rem;\n    }\n\n    &:not(.active):hover .label {\n      padding: calc(0.5rem + 2px) calc(1.042rem + 2px);\n    }\n\n    &.active {\n      font-weight: bold;\n      border: 0;\n      background-color: var(--color-light-blue);\n      box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);\n      & .label {\n        padding: calc(0.5rem + 2px) calc(1.042rem + 2px);\n      }\n\n      &:before {\n        background: linear-gradient(\n          0deg,\n          rgba(255, 255, 255, 0) 0%,\n          var(--color-white) 100%\n        );\n        content: \"\";\n        display: block;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        border-radius: 8px;\n        width: 100%;\n        z-index: 1;\n      }\n\n      &:after {\n        content: \"\";\n        width: 1rem;\n        height: 1rem;\n        position: absolute;\n        bottom: -0.458rem;\n        left: calc(50% + 0.5rem);\n        transform: translateX(-100%) rotateZ(45deg);\n        z-index: 0;\n        background: var(--color-light-blue);\n        box-shadow: 2px 2px 0 0 rgba(0, 0, 0, 0.16);\n      }\n    }\n\n    &:not(last-child) {\n      margin-right: 1.25rem;\n    }\n  }\n}\n\n.badge {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  .icon {\n    position: relative;\n    max-width: 160px;\n    // max-height: 160px;\n    width: 6.667rem;\n\n    .bg {\n      width: auto;\n      height: 100%;\n    }\n\n    .image {\n      position: absolute;\n      top: 0;\n      left: 0;\n      display: flex;\n      width: 100%;\n      height: auto;\n    }\n\n    .info {\n      position: absolute;\n      top: 0;\n      right: 0;\n      max-width: 2rem;\n      height: auto;\n      margin-top: -0.5rem;\n      width: 33%;\n      min-width: 1.15rem;\n      .text {\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: var(--color-green);\n        margin-top: -0.2rem;\n        font-size: 1rem;\n        font-weight: bold;\n        letter-spacing: 0;\n        text-align: center;\n      }\n    }\n  }\n  .box {\n    display: flex;\n    z-index: 2;\n    flex-direction: column;\n    justify-content: center;\n    border-radius: 2rem;\n    background: rgba(0, 51, 153, 0.2);\n    margin-top: -0.75rem;\n    text-align: center;\n    padding-left: 2rem;\n    padding-right: 2rem;\n\n    .title {\n      color: var(--color-white);\n      font-size: 1rem;\n      font-weight: bold;\n      letter-spacing: 0;\n      line-height: 1rem;\n      text-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.24);\n      padding-top: 0.5rem;\n    }\n    .description {\n      color: var(--color-primary-blue);\n      font-size: 0.667rem;\n      font-weight: 600;\n      line-height: 1rem;\n      padding-bottom: 0.3rem;\n    }\n  }\n  &.locked {\n    .icon .bg {\n      visibility: hidden;\n    }\n    .box {\n      background: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
